
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Playground, Props } from 'docz'
import Share from './share'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "share"
    }}>{`Share`}</h1>
    <hr />
    <h2 {...{
      "id": "share-1"
    }}>{`Share`}</h2>
    <h3 {...{
      "id": "description"
    }}>{`Description`}</h3>
    <p>{`A component to enable users to share links and content on specified platforms`}</p>
    <Playground __position={1} __code={'<Share\n  url=\"https://www.economist.com/leaders/2020/01/15/how-vladimir-putin-is-preparing-to-rule-for-ever\"\n  platforms={[\'Facebook\', \'Twitter\', \'LinkedIn\', \'WhatsApp\']}\n  text=\"You will like this story - economist.com \"\n  longtext=\"Take a look at this article I just found.\"\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Share
    }} mdxType="Playground">
    <Share url='https://www.economist.com/leaders/2020/01/15/how-vladimir-putin-is-preparing-to-rule-for-ever' platforms={['Facebook', 'Twitter', 'LinkedIn', 'WhatsApp']} text='You will like this story - economist.com ' longtext='Take a look at this article I just found.' mdxType="Share" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "share-with-callback"
    }}>{`Share (with callback)`}</h2>
    <h3 {...{
      "id": "description-1"
    }}>{`Description`}</h3>
    <p>{`Making use of a callback so users of this control can be notified when a sharing action has been made
(eg. for analytics). View the Developer Tools console to see the callback response.`}</p>
    <Playground __position={3} __code={'<Share\n  url=\"https://www.economist.com/leaders/2020/01/15/how-vladimir-putin-is-preparing-to-rule-for-ever\"\n  platforms={[\'Facebook\', \'Twitter\', \'LinkedIn\', \'WhatsApp\']}\n  text=\"You will like this story - economist.com \"\n  longtext=\"Take a look at this article I just found.\"\n  onShare={params => {\n    console.log(`You clicked the ${params.platform} icon`)\n  }}\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Share
    }} mdxType="Playground">
    <Share url='https://www.economist.com/leaders/2020/01/15/how-vladimir-putin-is-preparing-to-rule-for-ever' platforms={['Facebook', 'Twitter', 'LinkedIn', 'WhatsApp']} text='You will like this story - economist.com ' longtext='Take a look at this article I just found.' onShare={params => {
        console.log(`You clicked the ${params.platform} icon`);
      }} mdxType="Share" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "share-inverse"
    }}>{`Share (inverse)`}</h2>
    <h3 {...{
      "id": "description-2"
    }}>{`Description`}</h3>
    <p>{`A component to enable users to share links and content on specified platforms`}</p>
    <Playground __position={5} __code={'<Share\n  inverse\n  url=\"https://www.economist.com/leaders/2020/01/15/how-vladimir-putin-is-preparing-to-rule-for-ever\"\n  platforms={[\'Facebook\', \'Twitter\', \'LinkedIn\', \'WhatsApp\']}\n  text=\"You will like this story - economist.com \"\n  longtext=\"Take a look at this article I just found.\"\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Share
    }} style={{
      backgroundColor: "#333",
      margin: '-2em',
      padding: '2em'
    }} mdxType="Playground">
    <Share inverse url='https://www.economist.com/leaders/2020/01/15/how-vladimir-putin-is-preparing-to-rule-for-ever' platforms={['Facebook', 'Twitter', 'LinkedIn', 'WhatsApp']} text='You will like this story - economist.com ' longtext='Take a look at this article I just found.' mdxType="Share" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={Share} mdxType="Props" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;